import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Container, Form, Row, Card } from "react-bootstrap";
import logo from "assets/imgs/Logo-Principal-Brancopng.png";
import "../../../RedefinirSenha/styles.scss";

import { useNavigate } from "react-router-dom";

const ContentRecoveryEmailSent = () => {
  const navigate = useNavigate();

  return (
    <div className="content-wrapper">
      <Container>
        <Row className="vh-100 d-flex justify-content-center align-items-center content-redefinir-senha">
          <Col md={8} lg={10} xs={12}>
            <Card className="shadow">
              <Row className="g-0 h-100">
                <Col md={4} className="column-img-redefinir-senha ">
                  <img
                    src={logo}
                    alt="Imagem de registro"
                    className="img-fluid card-img"
                  />
                </Col>
                <Col md={8}>
                  <Card.Body className="h-100 d-flex flex-column m-3">
                    <div className="mb-3 mt-4">
                      <h3 className="fw-bold  mb-2">
                        Email de redefinição de senha enviado com sucesso.
                      </h3>
                      <label> </label>
                      <p>
                        Enviamos um email com as instruções de recuperação de
                        conta para o seu email. Siga as instruções para
                        redefinir sua senha.
                      </p>
                    </div>
                    <Button
                      variant="primary"
                      type="button"
                      onClick={() => navigate("/login")}
                    >
                      <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                    </Button>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContentRecoveryEmailSent;
